<template>
<v-autocomplete
  v-model="select"
  :items="items"
  :loading="loading"
  :search-input.sync="search"
  hide-no-data
  no-filter
  return-object

  :menu-props="{ offsetY: true, fixed: true }"
  :label="$t('Standort')"
  :placeholder="placeholder"

  no-data-text="Keine passenden Orte gefunden"
  attach
  @change="change"
  filled
  flat

  clearable
></v-autocomplete>
</template>

<script>
import { GeocoderFactory } from "./Geocoder";

export default {
  name: "GeocoderAutocomplete",

  props: [
    "value",
    "placeholder",
    "hide-details"
  ],

  data() {
    return {
      loading: false,
      search: null,
      select: null,
      items: []
    };
  },

  beforeDestroy() {
    this.destroyed = true;
    this.stopSearch();
  },

  created() {
    this.searchTimer = null;
    this.searchSeq = 0;

    GeocoderFactory().then(geocoder => {
      if (this.destroyed) {
        return;
      }

      this.geocoder = geocoder

      if (this.value.value) {
        this.items.push(this.value);
        this.select = this.value;
      }
    });
  },

  watch: {
    search(val) {
      if (!val || !val.trim()) {
        // Leere Eingabe: ausstehende Suche beenden, alte Treffer verwerfen
        this.stopSearch();
        this.items = this.select ? [this.select] : [];
        return;
      }

      if (this.select && val === this.select.text) {
        return;
      }

      this.querySelections(val);
    }
  },

  methods: {
    stopSearch() {
      if (this.searchTimer != null) {
        clearTimeout(this.searchTimer);
        this.searchTimer = null;
      }

      // Jede neue Suche und jeder Abbruch invalidiert ältere Antworten
      this.searchSeq = (this.searchSeq || 0) + 1;

      if (this.geocoder) {
        this.geocoder.cancelAutocomplete();
      }

      this.loading = false;
    },

    querySelections(value) {
      this.stopSearch();

      if (!this.geocoder) {
        return;
      }

      const seq = this.searchSeq;
      this.loading = true;

      this.searchTimer = setTimeout(() => {
        this.searchTimer = null;

        this.geocoder.autocomplete(value).then(items => {
          if (seq !== this.searchSeq) {
            return;
          }

          this.items = items.slice();
        }).finally(() => {
          if (seq === this.searchSeq) {
            this.loading = false;
          }
        });
      }, 150);
    },

    change(o) {
      this.stopSearch();
      this.$emit("change", o);
    }
  }
};
</script>
